import { GetStaticPaths } from 'next'
import { Durations } from '@/constants/durations'
import { slugs } from '@/constants/slugs'
import { DefaultLayout } from '@/layouts/DefaultLayout'
import { NextPageWithLayout } from '@/layouts/types'
import { getStaticPropsErrorHandler } from '@/utils/nextUtils/nextErrorHandlers'
import { useTranslate } from '@/utils/translate/translate-client'
import { loadTranslations } from '@/utils/translate/translate-server'
import { CustomExclusiveSceneView } from '@/views/ExclusiveSceneView/CustomExclusiveSceneView'

export const WeekAwaySneakPeekPage: NextPageWithLayout = () => {
  const { t } = useTranslate('the-shift-exclusive')

  return (
    <CustomExclusiveSceneView
      videoUrl="https://api.angelstudios.com/streaming/1438110e-7dc0-43f3-9dc6-5470036cb037/master.m3u8?ttl=94608000&ts=1754000924&v=5&s=S2MMdFQ3f9gPuB9clgdeXm37CmJqXHAyGiaSu70ffSysu%2Bb1XAgHYSY422mhWd2cE7LDcXKLB5aPWJAbZvNkjQ%3D%3D"
      imageUrl="https://images.angelstudios.com/image/upload/v1754074746/angel-studios/projects/a-week-away/A_Week_Away_Thumb-16x9.webp"
      canonical="https://www.angel.com/m/a-week-away-sneak-peek"
      title={t('aWeekAwayExclusiveSneakPeek', 'A Week Away Exclusive Sneak Peek')}
      description={t(
        'aWeekAwayExclusiveSneakPeekDescription',
        'Watch this never before seen exclusive sneak peek of A Week Away!',
      )}
      logoUrl="https://images.angelstudios.com/image/upload/v1755813270/studio-app/catalog/8cb64819-2d0a-4c44-974b-c36ccd379f70"
      projectSlug={slugs.aWeekAwaySeries}
    />
  )
}

export const getStaticPaths: GetStaticPaths = () => {
  return {
    paths: [{ params: { locale: 'en' } }],
    fallback: 'blocking',
  }
}

export const getStaticProps = getStaticPropsErrorHandler(
  { filePath: 'pages/[locale]/m/a-week-away-sneak-peek/index.tsx' },
  async ({ locale }) => {
    return {
      props: {
        ...(await loadTranslations(locale, [
          'common',
          'the-shift-exclusive',
          'guild',
          'join-the-guild',
          'guild-benefits',
        ])),
      },
      revalidate: Durations.ONE_DAY_IN_SECONDS,
    }
  },
)

WeekAwaySneakPeekPage.getLayout = (page) => {
  return (
    <DefaultLayout isDarkMode hideNavigation>
      {page}
    </DefaultLayout>
  )
}

export default WeekAwaySneakPeekPage
